import { Component } from '@angular/core';

@Component({
  selector: 'a3l-ui-dialog-header',
  template: '<ng-content></ng-content>',
  host: {
    class: 'a3l-ui-dialog__header',
  },
})
export class DialogHeaderComponent {
  /**
   * Create a new instance.
   */
  constructor() {
    //
  }
}
